import script from "./AddExcludedClientModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddExcludedClientModal.vue?vue&type=script&lang=ts&setup=true"

import "./AddExcludedClientModal.vue?vue&type=style&index=0&id=883f0278&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-883f0278"]])

export default __exports__